import { render, staticRenderFns } from "./InstrumentsAndIndices.vue?vue&type=template&id=b33dc1de&scoped=true"
import script from "./InstrumentsAndIndices.vue?vue&type=script&lang=js"
export * from "./InstrumentsAndIndices.vue?vue&type=script&lang=js"
import style0 from "./InstrumentsAndIndices.vue?vue&type=style&index=0&id=b33dc1de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b33dc1de",
  null
  
)

export default component.exports